import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

  constructor(public LANG: CommonUtilitiesService) { }

  ngOnInit() {
  }

}
